module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-selectize-plan"
  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
    attrs: {
      "value": _vm.value,
      "options": _vm.options,
      "value-field": "id",
      "maxItems": _vm.maxItems,
      "label-field": "name",
      "items": _vm.items,
      "searchField": _vm.searchableFields,
      "optionTemplate": _vm.optionTemplate,
      "renderTemplate": _vm.renderTemplate,
      "placeholder": "Plan",
      "allowEmptyOption": _vm.allowEmptyOption,
      "selectedValue": _vm.selectedValue
    },
    on: {
      "itemAdded": _vm.optionSelected,
      "itemRemoved": _vm.optionRemoved
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35280716!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/lists/selectize/SelectizePlan.vue
// module id = 2406
// module chunks = 1